import React, { useEffect } from "react";
import SeoMeta from "../../components/SeoMeta";
import { useTranslation } from 'react-i18next';
import { useLoading } from "../../contexts/LoadingContext";

import PageTitle from "./components/PageTitle";
import AllEvents from "./components/AllEvents";

function Events() {
  const { t } = useTranslation();
  const { setIsLoading } = useLoading();

  // Optionally simulate loading during layout mount
  useEffect(() => {
    setIsLoading(true);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 300); // Delay just enough to show the spinner briefly

    return () => clearTimeout(timeout);
  }, [setIsLoading]);

  return (
    <>
      {/* Inject SEO tags */}
      <SeoMeta
        title={t("events.SeoTitle", "Events and Exhibitions")}
        description={t("events.SeoDescription", "List of past, current, and upcoming exhibitions.")}
        keywords={t("events.SeoKeywords", "Events, Exhibitions")}
        robots="index, follow"
      />

      {/* Page content */}
      <section className="py-15 py-xl-20">
        <PageTitle />
        <AllEvents />
      </section>
    </>
  );
}

export default Events;

